export interface ExternalLinkState {
    renderModal: boolean;
    linkUrl: string;
    linkInnerHtml: string;
}

export interface AppContext {
    externalLinkState: ExternalLinkState;
}

export enum AppContextActions {
    SET_EXTERNAL_LINK_STATE = 'SET_EXTERNAL_LINK_STATE',
}
